import routePaths from "./routePaths";

const routePathsWithParams = [routePaths.NOTIFICATIONS_EDIT, routePaths.FW_VERSION_EDIT];

export default routePathsWithParams;
